import { render, staticRenderFns } from "./overlay-notification.vue?vue&type=template&id=4b38332a&scoped=true&lang=pug"
import script from "./overlay-notification.vue?vue&type=script&lang=js"
export * from "./overlay-notification.vue?vue&type=script&lang=js"
import style0 from "./overlay-notification.vue?vue&type=style&index=0&id=4b38332a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38332a",
  null
  
)

export default component.exports